// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--dca-con-bo-str{
    width: 100%;
    height: 100%;
    padding: 20px;
}

.scl--dca-con-bo-str.border-left{
    border-left: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--wdacs-bo-car-con-st:first-child .scl--dca-con-bo-str.border-left{
    border: none;
}

.scl--web-page-differ-section .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str.border-right{
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    border-left: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--web-page-differ-section:nth-child(even) .scl--dca-con-bo-str.border-left{
    border-left: none;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--dcbs-st-con-str{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 116px;
}

.scl--dcbs-con-met-st-str{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.scl--dcbs-con-met-st-str h6, .scl--dcbs-con-met-st-str p{
    margin: 0;
    font-family: var(--primary-font);
    font-weight: lighter;
}

.scl--dcbs-con-met-st-str h6{
    font-size: var(--font-size-body-l);
    color: var(--color-text-primary);
}

.scl--dcbs-con-met-st-str p{
    font-size: var(--font-size-body-md);
    color: var(--color-text-secondary);
}

.scl--dscs-con-ico-str{
    width: 100%;
}

.scl--dscs-con-ico-str--png img{
    width: 43px;
    height: 43px;
    object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/card/value/css/dynamicCard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".scl--dca-con-bo-str{\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n}\n\n.scl--dca-con-bo-str.border-left{\n    border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--wdacs-bo-car-con-st:first-child .scl--dca-con-bo-str.border-left{\n    border: none;\n}\n\n.scl--web-page-differ-section .scl--wdacs-bo-car-con-st .scl--dca-con-bo-str.border-right{\n    border-right: 1px solid rgba(255, 255, 255, 0.1);\n    border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--web-page-differ-section:nth-child(even) .scl--dca-con-bo-str.border-left{\n    border-left: none;\n    border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--dcbs-st-con-str{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 116px;\n}\n\n.scl--dcbs-con-met-st-str{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.scl--dcbs-con-met-st-str h6, .scl--dcbs-con-met-st-str p{\n    margin: 0;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n}\n\n.scl--dcbs-con-met-st-str h6{\n    font-size: var(--font-size-body-l);\n    color: var(--color-text-primary);\n}\n\n.scl--dcbs-con-met-st-str p{\n    font-size: var(--font-size-body-md);\n    color: var(--color-text-secondary);\n}\n\n.scl--dscs-con-ico-str{\n    width: 100%;\n}\n\n.scl--dscs-con-ico-str--png img{\n    width: 43px;\n    height: 43px;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
